import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import NumberFormat from "react-number-format";
import converter from "number-to-words";
export class PrintViewTakemoneyEn extends Component {
 render() {
  const { change_Lang, take_money_view, primary_logo_bill } = this.props;
  let converter1 =
   take_money_view.Amount && converter.toWords(take_money_view.Amount);
  return (
   <Fragment>
    <br />
    <br />
    <br />
    <br /> <br />
    <br />
    <br />
    <div>
     <div class="row">
      <div class="col-4">
       <p
        style={{
         fontSize: "19px",
         color: "#000",
         textAlign: "left",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} :&nbsp;
        <Time
         value={take_money_view.createdAt}
         format="hh:mm:ss"
         style={{
          fontSize: "19px",
          color: "#342800",
          fontWeight: "bold",
         }}
        />
        &nbsp;-{" "}
        <Time
         value={take_money_view.createdAt}
         format="YYYY-MM-DD"
         style={{
          fontSize: "19px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-4 ">
       <p
        style={{
         fontSize: "17px",
         color: "black",
         fontWeight: "bold",
         margin: "0px 0px 0px 0px",
        }}
        class=" d-flex justify-content-center"
       >
        {change_Lang("Repayment bills")}({change_Lang(take_money_view.type)})
       </p>
      </div>
      <div class="col-4 text-right">
       <p
        style={{
         fontSize: "19px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        #No&nbsp;:
        {take_money_view.invoice_No}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div class="row " style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fkb"
       >
        Receptor :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className=" col-form-label d-flex justify-content-start"
        style={{
         fontSize: "23px",
         color: "black",
        }}
       >
        {take_money_view.Money_recive}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        : وەرگر/المستلم
       </label>
      </div>
     </div>
     {/* second row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "white", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        بڕی پارە/مبلغ و قدره :
       </label>
      </div>
      <div
       class="col-6 d-flex justify-content-center"
       style={{ direction: "ltr" }}
      >
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={take_money_view.Amount}
        style={{
         fontSize: "23px",
         color: "black",
        }}
        className="col-form-label"
        prefix={`${take_money_view.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span
        style={{ marginTop: "14px", fontWeight: "bold", fontSize: "15px" }}
       >
        {" "}
        {converter1}&nbsp;
        {take_money_view.currency === "dolar" ? "US dollars" : "IQD Iraq"}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fkb"
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-8 d-flex justify-content-center">
       {take_money_view.type !== "investor" &&
       take_money_view.instead_of === "" ? (
        <span
         className="fk d-flex justify-content-center mt-2"
         style={{
          fontSize: "18px",
          color: "black",
          textAlign: "justify",
         }}
        >
         {take_money_view.type !== "Monthly rent invoice" ? (
          <>
           {change_Lang(take_money_view.type)} (
           {change_Lang(take_money_view.property)})&nbsp;
           {change_Lang("from")}
           &nbsp;({take_money_view.place}) &nbsp;
           {change_Lang("Number")}&nbsp;({take_money_view.num})
          </>
         ) : (
          <>
           {change_Lang(take_money_view.type)} (
           {change_Lang(take_money_view.property)})&nbsp;
           {change_Lang("from")}
           &nbsp;({take_money_view.place}) &nbsp;
           {change_Lang("Number")}&nbsp;({take_money_view.num}
           )&nbsp;
           {change_Lang("from")}&nbsp;
           {take_money_view.from}
           &nbsp;
           {change_Lang("to")}&nbsp;
           {take_money_view.to}
          </>
         )}
        </span>
       ) : (
        <span
         className="fk d-flex justify-content-center mt-2"
         style={{
          fontSize: "20px",
          color: "black",
          textAlign: "justify",
         }}
        >
         {take_money_view && take_money_view.instead_of}
        </span>
       )}
      </div>
      <div class="col-1 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fkb"
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "white", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "23px",
         color: "black",
        }}
       >
        {take_money_view.Money_provider}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label"
       >
        : The Payer
       </label>
      </div>
     </div>
     {/* note */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "18px",
         color: "black",
        }}
       >
        {take_money_view.note}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <br /> <br /> <br />
     <br />
     <div class="row">
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        (The payer)&nbsp;Signature
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        (Receptor)&nbsp;Signature
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",

         textAlign: "center",
        }}
        class=" col-form-label fk"
       >
        {take_money_view.Money_provider}
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",

         textAlign: "center",
        }}
        class=" col-form-label fk"
       >
        {take_money_view.Money_recive}
       </label>
      </div>
     </div>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    {/* Second Invoice */} <br />
    <br />
    <br />
    <br /> <br />
    <br />
    <br />
    <br />
    <div>
     <div class="row">
      <div class="col-4">
       <p
        style={{
         fontSize: "19px",
         color: "#000",
         textAlign: "left",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} :&nbsp;
        <Time
         value={take_money_view.createdAt}
         format="hh:mm:ss"
         style={{
          fontSize: "19px",
          color: "#342800",
          fontWeight: "bold",
         }}
        />
        &nbsp;-{" "}
        <Time
         value={take_money_view.createdAt}
         format="YYYY-MM-DD"
         style={{
          fontSize: "19px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-4 ">
       <p
        style={{
         fontSize: "17px",
         color: "black",
         fontWeight: "bold",
         margin: "0px 0px 0px 0px",
        }}
        class=" d-flex justify-content-center"
       >
        {change_Lang("Repayment bills")}({change_Lang(take_money_view.type)})
       </p>
      </div>
      <div class="col-4 text-right">
       <p
        style={{
         fontSize: "19px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        #No&nbsp;:
        {take_money_view.invoice_No}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div
      class="row "
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        وەرگر/المستلم :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className=" col-form-label d-flex justify-content-start"
        style={{
         fontSize: "23px",
         color: "black",
        }}
       >
        {take_money_view.Money_recive}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fkb"
       >
        : Receptor
       </label>
      </div>
     </div>
     {/* second row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "white", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        بڕی پارە / مبلغ و قدره :
       </label>
      </div>
      <div
       class="col-6 d-flex justify-content-center"
       style={{ direction: "ltr" }}
      >
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={take_money_view.Amount}
        style={{
         fontSize: "23px",
         color: "black",
        }}
        className="col-form-label"
        prefix={`${take_money_view.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span
        style={{ marginTop: "14px", fontWeight: "bold", fontSize: "15px" }}
       >
        {" "}
        {converter1}&nbsp;
        {take_money_view.currency === "dolar" ? "US dollars" : "IQD Iraq"}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fkb"
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-8 d-flex justify-content-center">
       {take_money_view.type !== "investor" &&
       take_money_view.instead_of === "" ? (
        <span
         className=" d-flex justify-content-center mt-2"
         style={{
          fontSize: "18px",
          color: "black",
          textAlign: "justify",
         }}
        >
         {take_money_view.type !== "Monthly rent invoice" ? (
          <>
           {change_Lang(take_money_view.type)} (
           {change_Lang(take_money_view.property)})&nbsp;
           {change_Lang("from")}
           &nbsp;({take_money_view.place}) &nbsp;
           {change_Lang("Number")}&nbsp;({take_money_view.num})
          </>
         ) : (
          <>
           {change_Lang(take_money_view.type)} (
           {change_Lang(take_money_view.property)})&nbsp;
           {change_Lang("from")}
           &nbsp;({take_money_view.place}) &nbsp;
           {change_Lang("Number")}&nbsp;({take_money_view.num}
           )&nbsp;
           {change_Lang("from")}&nbsp;
           {take_money_view.from}
           &nbsp;
           {change_Lang("to")}&nbsp;
           {take_money_view.to}
          </>
         )}
        </span>
       ) : (
        <span
         className=" d-flex justify-content-center mt-2"
         style={{
          fontSize: "20px",
          color: "black",
          textAlign: "justify",
         }}
        >
         {take_money_view && take_money_view.instead_of}
        </span>
       )}
      </div>
      <div class="col-1 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fkb"
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "white", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className=" col-form-label"
        style={{
         fontSize: "23px",
         color: "black",
        }}
       >
        {take_money_view.Money_provider}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label"
       >
        : The Payer
       </label>
      </div>
     </div>
     {/* note */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className=" col-form-label"
        style={{
         fontSize: "18px",
         color: "black",
        }}
       >
        {take_money_view.note}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <br /> <br /> <br />
     <div class="row" style={{ width: "100%" }}>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        (The payer)&nbsp;Signature
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",
        }}
        class=" col-form-label fk"
       >
        (Receptor)&nbsp;Signature
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",

         textAlign: "center",
        }}
        class=" col-form-label fk"
       >
        {take_money_view.Money_provider}
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "23px",
         color: "black",

         textAlign: "center",
        }}
        class=" col-form-label "
       >
        {take_money_view.Money_recive}
       </label>
      </div>
     </div>
    </div>
   </Fragment>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  take_money_view: state.Invoice_Reducer.take_money_view,
  index_takemoney: state.Invoice_Reducer.index_takemoney,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  primary_logo_bill: state.HelperReducer.primary_logo_bill,
  footer_logo_bill: state.HelperReducer.footer_logo_bill,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(
 mapStateToProps,
 mapDispatchToProps
)(PrintViewTakemoneyEn);
